// Shared Tailwind class string for rendering chapter HTML content from EPUBs,
// PDFs, and other ingested library items. Used by ChapterReader, PassageView,
// and ChapterPageView — extracted here to avoid 600-char duplication.
export const CHAPTER_CONTENT_CLASSES = [
  'chapter-content max-w-none',
  // Paragraphs
  '[&_p]:text-gray-800 [&_p]:leading-[1.75] [&_p]:text-lg dark:[&_p]:text-gray-200',
  '[&_p]:my-0 [&_p+p]:indent-6 [&_h3+p]:indent-0',
  // Headings
  '[&_h2]:text-xl [&_h2]:font-semibold [&_h2]:mt-8 [&_h2]:mb-3 [&_h2]:text-gray-900 dark:[&_h2]:text-white',
  '[&_h3]:text-lg [&_h3]:font-semibold [&_h3]:mt-6 [&_h3]:mb-2 [&_h3]:text-gray-900 dark:[&_h3]:text-white',
  '[&_h4]:text-base [&_h4]:font-semibold [&_h4]:mt-4 [&_h4]:mb-2 [&_h4]:text-gray-900 dark:[&_h4]:text-white',
  // Blockquotes
  '[&_blockquote]:border-l-4 [&_blockquote]:border-gray-300 dark:[&_blockquote]:border-gray-600',
  '[&_blockquote]:pl-4 [&_blockquote]:my-4 [&_blockquote]:italic [&_blockquote]:text-gray-600 dark:[&_blockquote]:text-gray-400',
  // Lists
  '[&_ul]:list-disc [&_ul]:pl-6 [&_ul]:my-3 [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:my-3 [&_li]:my-1',
  // Figures
  '[&_figure]:my-6 [&_figure_img]:max-w-full [&_figure_img]:h-auto [&_figure_img]:rounded',
  '[&_figcaption]:text-sm [&_figcaption]:text-gray-500 [&_figcaption]:mt-2 [&_figcaption]:text-center',
  // Horizontal rules
  '[&_hr]:my-8 [&_hr]:border-gray-200 dark:[&_hr]:border-gray-700',
  // Tables
  '[&_table]:w-full [&_table]:my-4 [&_table]:border-collapse',
  '[&_th]:border [&_th]:border-gray-300 dark:[&_th]:border-gray-600 [&_th]:px-3 [&_th]:py-2 [&_th]:text-left',
  '[&_td]:border [&_td]:border-gray-300 dark:[&_td]:border-gray-600 [&_td]:px-3 [&_td]:py-2',
  // Code
  '[&_pre]:bg-gray-100 dark:[&_pre]:bg-gray-800 [&_pre]:p-4 [&_pre]:rounded [&_pre]:my-4 [&_pre]:overflow-x-auto [&_code]:text-sm',
].join(' ');
